import { PayloadAction } from '@reduxjs/toolkit';
import { StepperState } from './types';

// Action to handle login
export const updateTestAction = (
  state: StepperState,
  action: PayloadAction<any>,
) => {
  state.test = action.payload;
};

// Action to handle logout
export const updateTest2Action = (state: StepperState) => {
  state.test2 = !state.test2;
};
